/*global define, require*/
/**
 * Add custom backbone validation methods
 */
define(
	'setupBackboneValidation',[
		'underscore',
		'BackboneValidation'
	],
	function (_, BackboneValidation) {
		'use strict';

		_.extend(BackboneValidation.validators, {
			/**
			 * Returns true if the value is a string of letters only (case insensitive)
			 * @param value
			 * @param attr
			 * @param customValue
			 * @param model
			 * @returns {undefined}
			 */
			letters: function (value, attr, customValue, model) {
				var isValid = /[a-z]+/i.test(value) && customValue,
					errorMsg = 'Please enter letters only';
				return isValid ? undefined : errorMsg;
			}
		});
	}
);

